import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../styles/Modal.css';

const AdditionalInfoModal = ({
    isOpen,
    onClose,
    onConfirm,
    slotsCount = 1,
    waitingListSlots = [],
    totalPendingCount = 0
}) => {
    const { t } = useTranslation('calendar');
    const [info, setInfo] = useState("");

    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm(info);
        setInfo(""); // Reset the input after confirming
    };

    const hasWaitingListSlots = waitingListSlots.length > 0;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{t('additionalInfo')}</h2>

                {hasWaitingListSlots && (
                    <div className="modal-warning">
                        <div className="modal-warning-icon">⚠️</div>
                        <div className="modal-warning-text">
                            {waitingListSlots.length === 1 && slotsCount === 1 ? (
                                <span dangerouslySetInnerHTML={{ __html: t('waitingListWarningSingle', { count: totalPendingCount }) }} />
                            ) : (
                                <span dangerouslySetInnerHTML={{ __html: t('waitingListWarningMultiple', { count: waitingListSlots.length, total: totalPendingCount }) }} />
                            )}
                        </div>
                    </div>
                )}

                <textarea
                    id="additional-info"
                    value={info}
                    onChange={(e) => setInfo(e.target.value)}
                    placeholder={t('additionalInfoPlaceholder')}
                    rows="4"
                    style={{ width: "100%" }}
                />
                <div className="modal-buttons">
                    <button className="cancel-btn" onClick={onClose}>
                        {t('common:cancel')}
                    </button>
                    <button className="save-btn" onClick={handleConfirm}>
                        {t('book')}{slotsCount > 1 ? ` (${slotsCount})` : ''}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdditionalInfoModal;
